import React from 'react';

import Icons from '@/core/components/Icons';
import type { AbstractRoute } from '@/core/lib/router/route';
import { useRouterContext } from '@/core/lib/router/router.context';

export interface MenuItemProps {
  leftIcon?: React.ReactElement;
  content: string;
  href: AbstractRoute;
  noPadding?: boolean;
  target?: '_blank';
  isInAppBrowser?: boolean;
}

const MenuItem: React.FC<MenuItemProps> = ({ href, leftIcon, content, noPadding, target, isInAppBrowser }) => {
  const { Link } = useRouterContext();
  return (
    <Link href={href} isInAppBrowser={isInAppBrowser} className={`flex w-full items-center justify-between space-x-1 bg-bg-primary py-4 ${noPadding ? '' : 'px-3'}`} target={target}>
      <div className="flex items-center space-x-3">
        <div>{leftIcon}</div>
        <div className="flex flex-col items-start">
          <p className="text-body-secondary font-medium text-content-primary">{content}</p>
        </div>
      </div>
      <div className="mx-2 flex items-center">
        <Icons icon="chevron-right" size="20" />
      </div>
    </Link>
  );
};

export default MenuItem;
